import {defer, type LoaderArgs} from '@shopify/remix-oxygen';
import {seoPayload} from '~/lib/seo.server';
import {AnalyticsPageType} from '@shopify/hydrogen';
import {routeHeaders, CACHE_SHORT} from '~/data/cache';
import * as _ from 'lodash';
import ComponentUtil from '~/components/ComponentUtil';
import {useGetContext} from '~/hooks/useGetContext';
import NavbarSection from '~/components/Sections/NavbarSection';
import {useLoaderData} from '@remix-run/react';
import {fetchSite} from '~/lib/storefrontFetcher';
import {get, getSiteDetails, getSiteSeo, processPageBlocks} from '~/utils';
import { block } from 'marked';
export const headers = routeHeaders;


export async function loader({params, context}: LoaderArgs) {
  const {language, country} = context.storefront.i18n;
  const site = await fetchSite({context});
  
  const {pages, articles, product_collections, faqs, meta} =
    await getSiteDetails(context, site);

  const {blocks, collectionProducts, allArticles, allFaqs} =
    await processPageBlocks({
      context,
      page: get(pages, '[0]', {}),
      articles,
      product_collections,
      faqs,
    });
  if (
    params.lang &&
    params.lang.toLowerCase() !== `${language}-${country}`.toLowerCase()
  ) {
    // If the lang URL param is defined, yet we still are on `EN-US`
    // the the lang param must be invalid, send to the 404 page
    throw new Response(null, {status: 404});
  }

  const seo = seoPayload.siteMeta(getSiteSeo({data: meta}));
  return defer(
    {
      // These different queries are separated to illustrate how 3rd party content
      // fetching can be optimized for both above and below the fold.
      language,
      country,
      articles,
      collectionProducts,
      allFaqs,
      analytics: {
        pageType: AnalyticsPageType.home,
      },
      seo,
      page: get(pages, '[0]', {}),
      blocks,
    },
    {
      headers: {
        'Cache-Control': CACHE_SHORT,
      },
    },
  );
}

export default function Homepage() {
  const {menuItems, logo, title, isAuthenticated, menu} = useGetContext();
  const {
    language,
    country,
    articles,
    collectionProducts,
    allFaqs,
    blocks,
    page,
  } = useLoaderData<typeof loader>();
  return (
    <>
      <NavbarSection
        menuItems={menuItems}
        headerStyle={get(page, 'style')}
        logo={logo || ''}
        title={title || ''}
        isAuthenticated={isAuthenticated}
        menu={menu}
      />
      <ComponentUtil
        collectionProducts={collectionProducts}
        articles={articles}
        language={language}
        country={country}
        allFaqs={allFaqs}
        pageSections={[]}
        blocks={blocks}
      />
    </>
  );
}

